export const PATRIMONY_ITEMS_PAGE_SIZE = 4;
